import { c as _c } from "react/compiler-runtime";
import type { FormData } from '../components/drawer-filter';
import useSOSFilingStatesQueryParams from './use-sos-filings-states-query-params';
const useInitialSOSFilingsFilters = () => {
  const $ = _c(6);
  const {
    values
  } = useSOSFilingStatesQueryParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      states: []
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const emptyValues = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let defaultData;
  if ($[2] !== values.filingsStates) {
    defaultData = {
      states: t1
    };
    if (values.filingsStates) {
      defaultData.states = values.filingsStates;
    }
    $[2] = values.filingsStates;
    $[3] = defaultData;
  } else {
    defaultData = $[3];
  }
  const defaultValues = defaultData;
  let t2;
  if ($[4] !== defaultValues) {
    t2 = {
      emptyValues,
      defaultValues
    };
    $[4] = defaultValues;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default useInitialSOSFilingsFilters;